// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32SEO","clinicsSelect":"styles_clinicsSelect__2ZHKe"};